import {
  Box,
  Fade,
  Skeleton,
  Stack,
  ThemeProvider,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { theme } from "../utilities/themes";
import backupImg from "../images/jpg/xl_1745960_cc176006.jpg";
import { Link } from "react-router-dom";
import { setPreferredExperience } from "../redux/slices/moviesSlice";
import { useDispatch } from "react-redux/es/exports";
import "./../css/App.scss";
import ReactTooltip from "react-tooltip";

const MovieCard = ({
  movieName = "jurassic",
  imgsrc = backupImg,
  genre = ["Action", "Adventure"],
  rating,
  duration = "2hrs",
  id = "thor",
  cinemaId = "",
  experience = "2D/3D",
}) => {
  const destination = cinemaId ? `/movie/${id}/${cinemaId}` : `/movie/${id}`;
  const [tooltipContent, setTooltipContent] = useState();
  const [loaded, setLoaded] = useState(false);
  const dispatch = useDispatch();
  const imgRef = useRef();
  const [_image, setImage] = useState("");
  useEffect(() => {
    const getImg = () => {
      let img = imgsrc;

      setImage(img);
      var src = img;
      var image = new Image();
      image.addEventListener("load", () => {
        setLoaded(true);
      });
      image.src = src;
    };
    getImg();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          flexBasis: {
            xs: "calc(50% - 2vw)",
            sm: "calc(100% / 3 - 2vw)",
            md: "calc(20% - 2vw)",
          },
          mr: "2vw",
          mb: 3,
        }}
      >
        <Box
          sx={{
            width: "100%",
          }}
        >
          {
            //#region the image and it's skeleton
          }

          <Box
            sx={{
              position: "relative",
              width: "100%",
              aspectRatio: "600/950",
            }}
          >
            <Link
              to={destination}
              style={{ width: "100%", height: "100%" }}
              onClick={() => dispatch(setPreferredExperience(experience))}
            >
              <Tooltip title="Click to book" placement="top">
                {!loaded ? (
                  <Fade in>
                    <Skeleton
                      variant="rectangular"
                      sx={{
                        borderRadius: "7px",
                        width: "100%",
                        height: "100%",
                      }}
                      animation="wave"
                    />
                  </Fade>
                ) : (
                  <img
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",

                      borderRadius: "7px",
                    }}
                    ref={imgRef}
                    src={_image}
                    alt={"food_image"}
                    className="searchPanelImg"
                    data-tip="click to book"
                    data-for={id}
                    onMouseOver={() => setTooltipContent("click to book")}
                    onMouseOut={() => setTooltipContent(null)}
                  />
                )}
              </Tooltip>
              {false && (
                <ReactTooltip
                  id={id}
                  getContent={() => {
                    return null;
                  }}
                  type="light"
                >
                  {tooltipContent && (
                    <Typography variant="body1" fontWeight={200}>
                      {tooltipContent}
                    </Typography>
                  )}
                </ReactTooltip>
              )}
            </Link>
          </Box>

          {
            //#endregion
          }
          {
            //#region name of the movie and other details
          }
          <Box
            component="div"
            sx={{
              position: "relative",
              width: "100%",
              overflow: "hidden",
            }}
          >
            <Stack>
              <Typography
                component="span"
                className="searchPanelLink"
                color="black"
                sx={{
                  fontSize: {
                    xs: "0.875rem",
                    sm: "1.125rem",
                  },
                }}
              >
                <Link
                  to={destination}
                  onClick={() => dispatch(setPreferredExperience(experience))}
                >
                  {movieName}
                </Link>
              </Typography>

              <Stack direction="row-reverse" justifyContent={"space-between"}>
                <Typography
                  component="span"
                  sx={{
                    fontSize: "0.75rem",
                    whiteSpace: "pre-wrap",
                    fontWeight: 300,
                  }}
                >
                  {duration}
                  &emsp;
                </Typography>
                {/* <Typography
                  component="span"
                  sx={{
                    fontSize: 12,
                    whiteSpace: "pre-wrap",
                    fontWeight: 300,
                  }}
                >
                  {genre.join(",")}
                </Typography> */}
                {rating !== undefined && (
                  <>
                    <Typography
                      component={"span"}
                      sx={{
                        fontSize: "0.75rem",
                        whiteSpace: "pre-wrap",
                        fontWeight: 300,
                      }}
                    >
                      {rating}
                    </Typography>
                  </>
                )}
              </Stack>
            </Stack>
          </Box>
          {
            //#endregion
          }
        </Box>
      </Box>
    </ThemeProvider>
  );
};
export default MovieCard;
